export const DOCUMENTS_BASE_URL = '/documents';
export const DASHBOARDS_BASE_URL = '/dashboards';
export const USER_BASE_URL = '/user';

export const PATHS = {
  DocumentsHome: DOCUMENTS_BASE_URL,
  Documents: `${DOCUMENTS_BASE_URL}/:folderId`,
  UserManagement: '/users',
  AddUser: `${USER_BASE_URL}/new`,
  EditUser: `${USER_BASE_URL}/:userId`,
  LogIn: '/login',
  ForgotPassword: '/forgot-password',
  ChangePassword: '/change-password',
  ValidateEmail: '/validate-email',
  PendingApproval: '/pending-approval',
  Favourites: '/favourites',
  Recents: '/recents',
  Dashboards: `${DASHBOARDS_BASE_URL}/workbooks`,
  DashboardsWorkbooks: `${DASHBOARDS_BASE_URL}/workbooks/:category?/:workbook?`,
  DashboardsSearch: `${DASHBOARDS_BASE_URL}/search`,
  Uploads: '/uploads',
};

export const DOCUMENTS_PATHS = [
  PATHS.Documents,
  PATHS.DocumentsHome,
  PATHS.PendingApproval,
  PATHS.Favourites,
  PATHS.Recents,
  PATHS.Uploads,
];

export const USER_MANAGEMENT_PATHS = [
  PATHS.UserManagement,
  PATHS.AddUser,
  PATHS.EditUser,
];
